<dx-popup
  title="Génération de statistiques"
  [(visible)]="displayed"
  resizeEnabled="true"
  width="600"
  height="auto">
  <div class="dialog-line">
    <div class="label">
      <span>Site</span>
    </div>
    <div class="value">
      <yo-lookup
        [data]="findAllLocalSites()"
        [selectedItem]="idSiteSelected"
        key="id"
        displayValue="libelle"
        [enableSearch]="true"
        placeholder="Sélectionner un site"
        (onValueChange)="onChangeSite($event)">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">
      <span>Année</span>
    </div>
    <div class="value">
      <yo-date-picker
        [value]="dateSelected"
        [selectLevel]="DateLevelEnum.YEAR"
        (onValueChange)="onChangeDate($event)">
      </yo-date-picker>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">
      <span>Points de télédéclaration</span>
    </div>
    <div class="value">
      <yo-tagbox
        [data]="pointsTeledeclaration"
        [selectedItems]="idsPointTeledeclatrationSelected"
        (onValueChange)="onChangePointLivraison($event)">
      </yo-tagbox>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        tooltip="Générer"
        iconClass="fas fa-save"
        [disabled]="!isGenerationPossible()"
        (onClick)="save()">
      </yo-button>
    </div>
  </div>
</dx-popup>
